var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2779_36730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5202 9.85474L19.4766 2.40234H18.0651L12.8932 8.87316L8.76242 2.40234H3.99805L10.2446 12.1874L3.99805 20.0023H5.40959L10.8713 13.1689L15.2337 20.0023H19.998L13.5199 9.85474H13.5202ZM11.5869 12.2736L10.954 11.2992L5.91819 3.54606H8.08625L12.1502 9.80309L12.7831 10.7775L18.0658 18.9106H15.8977L11.5869 12.2739V12.2736Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2779_36730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.921352cade9295bc966c0ff43a4ec1df.svg";
export { ForwardRef as ReactComponent };